import React from "react";
import { StyledResourceLabel } from "./styles";
export const ResourceLabelContent = ({ itemProps, option }) => {
  return (
    <StyledResourceLabel {...itemProps}>
      <p className="primary">{option.label}</p>
      <p className="secondary">{option.secondaryLabel}</p>
    </StyledResourceLabel>
  );
};
